module.exports = __webpack_public_path__ + "media/src/images/certificates/milestone_completed-b6015a546d6d77291230b1a777e6eb0e.png";